/**
 * Created by admin on 2018/3/5.
 */
import Vue from 'vue';
import VeeValidate, {Validator} from 'vee-validate';
import zh_CN from 'vee-validate/dist/locale/zh_CN'
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: 'zh_CN',
})
Vue.use(VeeValidate, {
    i18n,
    i18nRootKey: 'validation',
    dictionary: {
        zh_CN
    }
});
// 自定义validate
const dictionary = {
    zh_CN: {
        messages: {
            email: () => '请输入正确的邮箱格式',
            required: ( field )=> '此项不能为空'
        },
        attributes:{
            email:'邮箱',
            password:'密码',
            name: '账号',
            phone: '手机'
        }
    }
};
Validator.localize(dictionary);
Validator.extend('idcard',{
    getMessage(field,args){
        return '请输入正确的身份证号码'
    },
    validate(value){
        return  value.length == 18 && /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)
    }
})
export default Validator;


// WEBPACK FOOTER //
// ./src/service/validate.js